import { FeatureUnit } from "@omni/types/api/product/bff/shared/featureUnit.model";
import { ProductTileFeatureUnit } from "@omni/types/api/product/bff/shared/productTileFeatureUnit.model";
import { CloudFeatureUnit } from "@omni/types/api/product/cloud/shared/featureUnit.model";
import { NullableModelMapper } from "@omni/types/utils/modelMapper";

const fromCloudtoBff: NullableModelMapper<CloudFeatureUnit, FeatureUnit> = (
    model
) => {
    if (!model) {
        return null;
    }

    return {
        name: model.name,
        code: model.code,
        symbol: model.symbol
    } satisfies FeatureUnit;
};

const fromAlgoliaSearchToProductTile: NullableModelMapper<
    string,
    ProductTileFeatureUnit
> = (model) => {
    if (!model) return null;

    return {
        name: model,
        code: model
    } satisfies ProductTileFeatureUnit;
};

const fromBffSearchToProductTile: NullableModelMapper<
    string,
    ProductTileFeatureUnit
> = (model) => {
    if (!model) return null;

    return {
        name: model,
        code: model
    } satisfies ProductTileFeatureUnit;
};

export const FeatureUnitMapper = {
    fromCloudtoBff: fromCloudtoBff,
    fromAlgoliaSearchToProductTile: fromAlgoliaSearchToProductTile,
    fromBffSearchToProductTile: fromBffSearchToProductTile
};
